import axios, { AxiosRequestHeaders } from "axios";
import { FormEventHandler, useRef, useState } from "react";
import { ILoginData2 } from "../../../models";
import { HOSTNAME } from "../api-utils";
import { ApiTesterComponent, IApiFetcher } from "../ApiTesterApp";

export const tracksExploreSearchGet: IApiFetcher = async ({
  ss,
  utoken,
  omitUserAgent = false,
  filterOn = false
}: {
  ss: string,
  utoken: string;
  omitUserAgent?: boolean;
  filterOn?: boolean;
}) => {
  const headers: AxiosRequestHeaders = {};
  if (!omitUserAgent) {
    headers["User-Agent"] = "I:2.5.0(256)";
  }
  headers["utoken"] = utoken;

  const response = await axios.get<any>(`${HOSTNAME}${tracksExploreSearchGet.url}`, {
    headers,
    validateStatus: () => true,
    params: {
      ss,
      filterOn
    }
  });
  return response.data;
};
tracksExploreSearchGet.url = "/wp-json/wp/v3/tracks/explore_search";
tracksExploreSearchGet.method = 'GET';

const TracksExploreSearch: ApiTesterComponent = ({
  loginData,
}: {
  loginData: ILoginData2 | null;
}) => {
  const searchStringRef = useRef<HTMLInputElement>(null);
  const filterOnRef = useRef<HTMLInputElement>(null);
  const [data, setData] = useState<string>("");
  const [loading, setIsLoading] = useState<boolean>(false);

  const onSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    if (!loginData?.token) return;
    if(!searchStringRef) return;
    if(!filterOnRef) return;

    const filterOn = filterOnRef.current?.checked ?? false;
    console.log({filterOn});

    setIsLoading(true);
    tracksExploreSearchGet({
      ss: searchStringRef.current?.value,
      utoken: loginData.token,
      omitUserAgent: true,
      filterOn
    }).then((data) => {
      setIsLoading(false);
      setData(JSON.stringify(data, null, 2));
    });
  };

  return (
    <div className="space-y-1">
      <div className="p-2">
        <h3 className="text-xl font-bold my-2">TracksExploreSearch</h3>
        <form onSubmit={onSubmit}>
          <label className="block">
            <span className="inline-block mr-2">Search String</span>
            <input className="border px-2 py-1" type="text" ref={searchStringRef} />
          </label>
          <label className="block">
            <span className="inline-block mr-2">Filter On</span>
            <input className="border px-2 py-1" type="checkbox" ref={filterOnRef} />
          </label>
          <div><button className="border px-2 py-1" type="submit">Fetch</button></div>
        </form>
      </div>
      <pre>{loading ? "Loading..." : data}</pre>
    </div>
  );
};

TracksExploreSearch.fetcher = tracksExploreSearchGet;

export default TracksExploreSearch;
